import { SELECTED_LANGUAGE_KEY } from '../../constants';
import { DefaultLocalStorageService } from '../local-storage-service';
import { HasDependencies } from '../types';
import { availableLanguagesToIso6291Map, languages } from './constants';
import { LanguageObject } from './types';

export class LocalStorageLanguageService implements HasDependencies {
  private service = new DefaultLocalStorageService(SELECTED_LANGUAGE_KEY);

  public getDeps = (): (string | undefined)[] => [];

  public get = (): LanguageObject => {
    const stored: string | null = this.service.get();
    const languageId = stored
      ? availableLanguagesToIso6291Map[stored]
      : languages[0].id; // TODO: double check if that's a good default
    return languages.find((lng) => lng.id === languageId) ?? languages[0];
  };

  public set = (value: LanguageObject) => {
    this.service.set(value.id);
  };
}
